<template>
	<BudgetHealthCharts
		:project-id="projectId"
		:retainer-period-id="retainerPeriodId"
	/>
</template>

<script setup lang="ts">
import { BudgetHealthCharts } from '@/features/Project';
import { type RetainerPeriod, type Project } from '@/generated/graphql';

defineProps<{
	projectId: Project['id'];
	retainerPeriodId?: RetainerPeriod['id'];
}>();
</script>
